import { Controller } from '@hotwired/stimulus';
import { Loader } from '@googlemaps/js-api-loader';
import { vehicleMarkerTemplate } from './../components/maps/marker'
import consumer from '../channels/consumer'
import { MapsRegistry } from '../components/maps/maps_registry';

export default class extends Controller {
  static targets = [
    'mapContainer',
    'infoPanel',
    'infoPanelTitle',
    'infoPanelContent',
    'lastUpdateTime',
    'statusIndicator',
    'refreshButton',
    'vehiclesList'
  ];

  static values = {
    apiKey: String,
    telemetry: Object,
    autoRefresh: { type: Boolean, default: true },
    refreshInterval: { type: Number, default: 30000 },
    updateInterval: { type: Number, default: 30000 }
  };

  connect() {   
    this._loader = new Loader({
      apiKey: this.apiKey,
      version: 'weekly',
      libraries: ['geometry']
    });

    this.map = null;
    this.bounds = null;
    this.initializeMap();
  }

  disconnect() {
    this.clearMarkers();
  }

  async initializeMap() {
    const { Map } = await this._loader.importLibrary('maps');
    const { LatLngBounds } = await this._loader.importLibrary('core');
    this.bounds = new LatLngBounds();
    const defaultCenter = { lat: -23.550520, lng: -46.633308 };

    this.map = new Map(this.mapContainerTarget, {
      center: defaultCenter,
      zoom: 12,
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        mapTypeIds: ['roadmap', 'satellite', 'hybrid']
      },
      streetViewControl: true,
      fullscreenControl: true,
      zoomControl: true,
      styles: this.getMapStyles(),
    });

    this.registry = new MapsRegistry(this.map, this._loader, this.bounds);
    this.handleDevices = this.handleDevices.bind(this);
    
    this.InitDevicePolling();
  }

  InitDevicePolling() {}

  handleDevices(devices){
    this.registry.updateAll(devices);
  }


  startDevicePolling({ url, interval = 30000, onUpdate}) {
    let timer = null

    async function poll() {
      try {
        const response = await fetch(url, {
          credentials: "same-origin"
        })

        if (!response.ok) throw new Error("Polling failed")

        const payload = await response.json()
        onUpdate(payload.vehicles)
      } catch (error) {
        console.error("Device polling error:", error)
      }
    }

    poll()
    timer = setInterval(poll, interval)

    return () => clearInterval(timer)
  }

  getMapStyles() {
    if (document.documentElement.classList.contains('dark')) {
      return [
        { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] }
      ];
    }
    return [];
  }

  selectVehicle(event) {
    let data = event.currentTarget.dataset
    this.registry.panToMarker(data.vehicleId);
  }

  setMapType(event) {
    const mapType = event.currentTarget.dataset.mapType;  
    if (this.map) {
      this.map.setMapTypeId(mapType);
    }
  }
}
